export default "__VITE_ASSET__c665dbd2__"